import { BrowserAuthError, InteractionRequiredAuthError } from '@azure/msal-browser';

/**
 * Detect MSAL errors that require an interactive (full-page) re-login.
 *
 * Casi coperti:
 *  - InteractionRequiredAuthError: refresh token scaduto, login_required, consent_required.
 *  - BrowserAuthError con codice noto di silent iframe bloccato (B2C risponde
 *    X-Frame-Options: deny su `/oauth2/v2.0/authorize`, quindi qualsiasi
 *    silent iframe acquire fallisce con monitor_window_timeout / hash_empty
 *    / block_iframe_reload). Questi NON sono recuperabili senza un nuovo
 *    login full-page.
 *  - Risposta esplicita B2C `invalid_grant` / `AADB2C90085` (refresh token
 *    non piu` utilizzabile lato server) propagata da MSAL come errore generico.
 *
 * Quando true: silent acquire NON tornera` mai a funzionare senza un nuovo
 * login interattivo. Il caller deve fare clear cache + redirect a /login,
 * non ritentare in loop.
 */
export function isInteractionRequiredError(error: unknown): boolean {
  if (!error) return false;

  if (error instanceof InteractionRequiredAuthError) return true;

  if (error instanceof BrowserAuthError) {
    return BROWSER_AUTH_INTERACTION_CODES.has(error.errorCode);
  }

  const err = error as { errorCode?: string; errorMessage?: string; message?: string };
  if (err.errorCode && BROWSER_AUTH_INTERACTION_CODES.has(err.errorCode)) return true;

  const message = ((err.errorMessage ?? '') + ' ' + (err.message ?? '')).toLowerCase();
  return message.includes('invalid_grant') || message.includes('aadb2c90085');
}

const BROWSER_AUTH_INTERACTION_CODES = new Set<string>([
  'monitor_window_timeout',
  'hash_empty_error',
  'no_token_request_cache_error',
  'interaction_in_progress',
  'block_iframe_reload',
  'empty_window_error',
]);
